// import React from 'react';
// import PortfolioData from './PortfolioData'
// import './Portfolio.css';

// function Portfolio() {
//     return (
        // <section id="portfolio" className="container section">
        // <div className="row">
        //   <div
        //     className="col-md-10"
        //     data-aos="fade-up"
        //     data-aos-easing="linear"
        //     data-aos-duration="500"
        //   >
        //     <h2 id="skill_header" className="section__title">
        //       Portfolio_
        //     </h2>
        //   </div>
        // </div>
        // <div
        //     className="col-md-10 container"
        //     data-aos="fade-up"
        //     data-aos-easing="linear"
        //     data-aos-duration="500"
        //     style={{color:"black"}}
        //   >
        //     Est do sint nostrud duis est nostrud incididunt ullamco aliquip tempor elit. In eu est voluptate nisi in occaecat cupidatat. Fugiat qui tempor adipisicing voluptate enim aliquip. Laboris officia esse Lorem velit eu sunt fugiat sint. Dolore eiusmod culpa fugiat veniam elit consequat laborum.Minim velit minim ullamco reprehenderit quis sit tempor minim quis officia magna anim. Ex aute consectetur aliquip tempor. Fugiat in incididunt laborum qui voluptate exercitation aliqua.Proident voluptate labore tempor et ullamco do cupidatat consequat cupidatat velit elit Lorem. Ut aliquip adipisicing culpa id enim commodo non nisi irure cillum laboris laboris. Quis fugiat sunt veniam velit enim. Officia enim ut deserunt nisi et velit. Mollit et sunt enim cillum consequat consectetur cillum duis aliqua. Magna consectetur incididunt sit consequat elit nisi non ut anim dolor culpa nulla. Sit excepteur in Lorem aliqua fugiat dolor labore aliqua pariatur Lorem.Cillum officia laborum consequat sint deserunt commodo cillum in esse anim ipsum commodo fugiat. Mollit consequat ex ut pariatur non reprehenderit magna ut occaecat. Eiusmod eiusmod irure reprehenderit dolor minim consectetur ex. Cillum ea ad nisi ipsum aute ad ex est consectetur est labore cillum nisi ad. Ut proident sint irure irure nulla ipsum et irure adipisicing ipsum aliqua. Proident nostrud pariatur nulla quis adipisicing eu reprehenderit.           
        //     Fugiat enim id qui ullamco consequat excepteur quis reprehenderit pariatur eu. Est sunt ex laborum laboris laboris consectetur officia consectetur laboris. Dolor laboris sint esse duis.
        // </div>
        // </section>
//     )
// }

// export default Portfolio

import React, { useState } from 'react'
import './Portfolio.css'
import portfolioData from './PortfolioData'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

function Portfolio() {
  const [modalShow, setModalShow] = useState(false);
  const [tempData, setTempData] = useState({})

  function createModal(data) {
    return (
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {data.desc}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{data.summary}</p>
          <Image src={data.image} style={{ width: '200px' }} />
        </Modal.Body>
         {/* make sure to add rel="noreferrer" for netlify upload */}
          <a id="portfolio__modal__link" href={data.link} target="_blank" rel="noreferrer">Go to site</a>
          <a id="portfolio__modal__link" href={data.githublink} target="_blank" rel="noreferrer">Go to github</a>
        <Modal.Footer>
          <div>Technologies used: </div>
          <p style={{ fontSize: '0.7rem', marginRight: 'auto' }}>{data.tech}</p>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  const mapped = portfolioData.map((e, idx) => {
    return (
      <Card key={idx} id="portfolio__card__container">
        <Image className="portfolio__image" onClick={(a) => {
          setTempData({
            image: e.image,
            link: e.link,
            desc: e.desc,
            summary: e.summary,
            tech: e.tech,
            githublink: e.githublink
          })
          setModalShow(true)
        }}
          src={e.image} />
        <div className="portfolio__click__info">&#x1F50E;&#xFE0E;</div>
        {createModal(tempData)}
      </Card>
    )
  })

  return (
    <section id="portfolio" className="container section">
    <div className="row">
      <div
        className="col-md-10"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="500"
      >
        <h2 id="skill_header" className="section__title">
          Portfolio_
        </h2>
      </div>
    </div>
    <div
        className="col-md-10"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="500"
        style={{color:"black"}}
      >
        <Container fluid="lg" style={{ padding: '2rem 0' }}>
        <Row>
          {mapped}
        </Row>
      </Container>
    </div>
    </section>

    


  );
}

export default Portfolio


